import whenDomReady from 'when-dom-ready';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import debounce from 'lodash/debounce';
function initialise() {
    const burger = document.querySelector('.js-burger');
    const nav = document.querySelector('.js-nav');
    const menuItems = Array.from(document.querySelectorAll('.js-has-dropdown'));
    const closeButtons = Array.from(document.querySelectorAll('.js-close-burger'));
    const navItems = Array.from(document.querySelectorAll('.js-nav-item'));
    const DesktopWidth = 1024;
    if (!burger || !menuItems || !nav) {
        return;
    }
    const ACTIVE = 'is-active';
    const OPEN = 'is-open';
    if (closeButtons.length > 0) {
        closeButtons.forEach(button => {
            button.addEventListener('click', () => burger.click());
        });
    }
    burger.addEventListener('click', () => {
        if (DesktopWidth < window.innerWidth) {
            return;
        }
        nav.classList.add(ACTIVE);
        if (burger.classList.contains(ACTIVE)) {
            nav.classList.remove(ACTIVE);
            burger.classList.remove(ACTIVE);
            enableBodyScroll(nav);
        }
        else {
            disableBodyScroll(nav);
            window.scrollTo(0, 0);
            burger.classList.add(ACTIVE);
        }
    });
    menuItems.forEach(item => {
        item.addEventListener('click', e => {
            if (DesktopWidth < window.innerWidth) {
                return;
            }
            e.preventDefault();
            if (item.classList.contains(OPEN)) {
                item.classList.remove(OPEN);
            }
            else {
                item.classList.add(OPEN);
            }
        });
    });
    navItems.forEach(item => {
        item.addEventListener('click', e => {
            if (DesktopWidth > window.innerWidth) {
                e.stopPropagation();
            }
        });
    });
    function removeBodyScrollLock() {
        if (!burger || !nav) {
            return;
        }
        if (DesktopWidth < window.innerWidth) {
            nav.classList.remove(ACTIVE);
            burger.classList.remove(ACTIVE);
            enableBodyScroll(nav);
        }
    }
    window.addEventListener('resize', debounce(() => removeBodyScrollLock(), 100));
}
whenDomReady().then(initialise);
